import { render } from "./SettingKillCounts.vue?vue&type=template&id=dc92ad10&scoped=true"
import script from "./SettingKillCounts.vue?vue&type=script&lang=js"
export * from "./SettingKillCounts.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=dc92ad10&scoped=true&lang=css&external"
import "./SettingKillCounts.vue?vue&type=style&index=1&id=dc92ad10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc92ad10"]])

export default __exports__